// extracted by mini-css-extract-plugin
export default {"base":"vp_craAl","wrapper":"vp_eE9Dk","arrow":"vp_F5nnL","description":"vp_MXWJX"};